/** True when axios/fetch aborted via AbortSignal (or legacy cancel). */
export function isAbortError(error) {
    return (
        error?.code === 'ERR_CANCELED' ||
        error?.name === 'CanceledError' ||
        error?.name === 'AbortError'
    );
}
